import { color } from "@ui";
import * as io from "io-ts";

export const Reparability = io.keyof({
  REPARABILITY_0: null,
  REPARABILITY_1: null,
  REPARABILITY_2: null,
});
export type Reparability = io.TypeOf<typeof Reparability>;
export const reparabilities = Object.keys(Reparability.keys) as (keyof typeof Reparability.keys)[];
export const REPARABILITY_COLOR: Record<Reparability, string> = {
  REPARABILITY_0: color.raw.chlorine700,
  REPARABILITY_1: color.raw.phosphorus400,
  REPARABILITY_2: color.raw.oxygen300,
};
